export default "<span class=\"button-container\" (click)=\"doEdit()\">\r\n    <i class=\"fas fa-ellipsis-h\"></i>\r\n</span>"